'use client';

import Link from 'next/link';
import { useActionState } from 'react';
import { useFormStatus } from 'react-dom';
import type { AuthState } from '@/app/actions/auth';
import { Button, FormError, Input, Label } from '@/components/ui';

function SubmitButton({ label }: { label: string }) {
  const { pending } = useFormStatus();
  return (
    <Button type="submit" size="lg" className="w-full" disabled={pending}>
      {pending ? 'Working…' : label}
    </Button>
  );
}

export function AuthForm({
  mode,
  action,
}: {
  mode: 'login' | 'signup';
  action: (prev: AuthState, formData: FormData) => Promise<AuthState>;
}) {
  const [state, formAction] = useActionState<AuthState, FormData>(action, {});
  const isSignup = mode === 'signup';

  return (
    <form action={formAction} className="space-y-4">
      <FormError>{state.error}</FormError>

      {isSignup ? (
        <div className="space-y-1.5">
          <Label htmlFor="name">Name</Label>
          <Input id="name" name="name" autoComplete="name" placeholder="Ada Lovelace" />
        </div>
      ) : null}

      <div className="space-y-1.5">
        <Label htmlFor="email">Work email</Label>
        <Input
          id="email"
          name="email"
          type="email"
          required
          autoComplete="email"
          placeholder="you@startup.com"
        />
      </div>

      <div className="space-y-1.5">
        <Label htmlFor="password">Password</Label>
        <Input
          id="password"
          name="password"
          type="password"
          required
          minLength={isSignup ? 8 : undefined}
          autoComplete={isSignup ? 'new-password' : 'current-password'}
          placeholder={isSignup ? 'At least 8 characters' : '••••••••'}
        />
      </div>

      <SubmitButton label={isSignup ? 'Create account' : 'Log in'} />

      <p className="pt-1 text-center text-sm text-ink-500">
        {isSignup ? 'Already have an account? ' : 'New to PitchVault? '}
        <Link
          href={isSignup ? '/login' : '/signup'}
          className="font-medium text-brand-600 hover:text-brand-700"
        >
          {isSignup ? 'Log in' : 'Create an account'}
        </Link>
      </p>
    </form>
  );
}
